import React, { Component } from 'react';
import { connect } from 'react-redux';
// import history from '../history';

import { answerQuestion } from '../actions/quiz';
import { changeColor } from '../actions/backgroundColor';

import FeedbackCardsRulesView from "./FeedbackCardsRulesView";
import SituationCardsRulesView from "./SituationCardsRulesView";
import QuestionSingleChoice from '../components/QuestionSingleChoice.jsx';
import QuestionKeywords from '../components/QuestionKeywords';

// import QuestionHeader from '../components/QuestionHeader.jsx';
// import { Link } from 'react-router-dom';

class QuizQuestionView extends Component {

	constructor(props) {
		super(props);
		this.renderQuestion = this.renderQuestion.bind(this);
		this.handleAnswerQuestion = this.handleAnswerQuestion.bind(this);

		// let iQuestionID = parseInt(props.match.params.questionID, 10);
		// //Check if they don't skip steps
		// if(iQuestionID > 1) {
		// 	if(props.quiz.questions[iQuestionID = iQuestionID - 2].givenAnswers.length === 0) {
		// 		history.push(`/quiz/1`);
		// 	}
		// }
	}

	handleAnswerQuestion(answer) {
		const { quiz } = this.props,
				questionID = this.props.match.params.questionID;

		this.props.answerQuestion(answer, quiz, questionID);
	}

	renderInvalidQuestion() {
		return (
			<p>Invalid question</p>
		);
	}

	renderQuestion() {
		const questionID = parseInt(this.props.match.params.questionID, 10);
		var oCurrentQuestion = {};
		const { quiz } = this.props;

		if (!quiz) return this.renderInvalidQuestion();

		//state returns an object.. Why? dont know but fix it by converting it to a array
		let aQuestions = typeof(quiz.questions === 'object') ? Object.keys(quiz.questions).map(key => quiz.questions[key]) : quiz.questions;

		aQuestions.forEach(oQuestion => {
			if(parseInt(oQuestion.id, 10) === questionID) {
				oCurrentQuestion = oQuestion;
			}
		});

		//Change background color if defined
		if(oCurrentQuestion['bgColor']) {
			this.props.backgroundColor(oCurrentQuestion['bgColor']);
		} else {
			this.props.backgroundColor("transparent");
		}

		switch(oCurrentQuestion.type) {

			case 'single-choice':
				return (<QuestionSingleChoice
					oQuestion={oCurrentQuestion}
					onAnswerQuestion={this.handleAnswerQuestion}					
				/> );

			case 'keywords':
				return (<QuestionKeywords
					oQuestion={oCurrentQuestion}
					onAnswerQuestion={this.handleAnswerQuestion}
				/>);
				
			case 'situation-cards-rules':
				return (<SituationCardsRulesView />);

			case 'feedback-cards-rules':
				return (<FeedbackCardsRulesView />);

			default:
				return this.renderInvalidQuestion();
		}
	}
	render() {
		const questionRendered = this.renderQuestion();
		// const questionID = this.props.match.params.questionID;
		// const { quiz } = this.props;

		return (
	  		<div>
	  			{/* disable it for now-- since we have each section's progress already <QuestionHeader quiz={quiz} questionID={questionID} /> */}
				{questionRendered}
	  		</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		answerQuestion: function(answer, quiz, questionID) { dispatch(answerQuestion(answer, quiz, questionID)) },
		backgroundColor: function(color) { dispatch(changeColor(color)) }
	};
}

function mapStateToProps({ quiz }, { match: { params } }) {
	return { quiz };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuizQuestionView);



// WEBPACK FOOTER //
// ./src/views/QuizQuestionView.jsx